export const layout = {
  pageMaxWidth: 1440,
};
